export function getMenuConfig(user) {
    return [
        {
            id: "geral",
            nav: true,
            section: "Geral",
            icon: "🏠",
            shortLabel: "Início",
            items: [
                { label: "Home", icon: "🏠", rota: "/home" },
            ]
        },
        {
            id: "dp-rh",
            nav: true,
            section: "DP / RH",
            icon: "👥",
            shortLabel: "DP/RH",
            items: [
                { label: "Meu Cadastro", icon: "👤", url: `http://186.237.132.27:9033/m/?tipace=5&token=${user?.toksim}&cpf=${user?.cpffun}` },
                { label: "Informações", icon: "📊", rota: "/informacoes" },
                { label: "Refeição", icon: "🍽️", rota: "/refeicao" },
                { label: "Engajamento", icon: "🎯", rota: "/engajamento" },
                { label: "Ponto Eletrônico", icon: "⏱️", url: "https://centraldofuncionario.com.br/124663/" },
            ]
        },
        {
            id: "esporte",
            nav: true,
            section: "Esporte / Saúde",
            icon: "🏃",
            shortLabel: "Esporte",
            items: [
                { label: "Agendamento de Atividades", icon: "🗓️", url: `http://186.237.132.27:9033/m/?tipace=a&token=${user?.toksim}&cpf=${user?.cpffun}` },
                { label: "Gestão de Esportes", icon: "🏅", url: `http://186.237.132.27:9033/m/?tipace=b&token=${user?.toksim}&cpf=${user?.cpffun}` },
            ]
        },
        {
            id: "seguranca",
            nav: true,
            section: "Segurança do Trabalho",
            icon: "🛡️",
            shortLabel: "Segurança",
            items: [
                { label: "Documentos de Orientação", icon: "🦺", url: `http://186.237.132.27:9033/m/?tipace=j&token=${user?.toksim}&cpf=${user?.cpffun}` },
            ]
        },
        {
            id: "diversos",
            nav: true,
            section: "Diversos",
            icon: "⚙️",
            shortLabel: "Diversos",
            items: [
                { label: "Procedimentos / Manuais", icon: "📚", url: "https://drive.google.com/drive/u/0/folders/1xfrVhijPNt4bYY4O2YxSyVjJOy9cNVaW" },
                { label: "Política de Privacidade", icon: "🔐", url: "https://www.cozimax.com.br/esg#politica-de-privacidade" },
            ]
        },
    ];
}
